import pluralize from "pluralize";
import { useEffect, useState } from "react";
import {
  Col,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import StrUtils from "utils/StrUtils";

/**
 * @param {any} records
 * @param {any} pagination
 * @param {any} query
 * @param {any} setQuery
 * @param {any} error
 * @param {any} setSelectedRecords
 * @param {any} loading
 * @param {any} module
 * @param {any} containerCSS
 * @param {any} sticky
 */
const AppTablePagination = ({
  records,
  pagination,
  query,
  setQuery,
  error,
  setSelectedRecords,
  loading = false,
  module,
  containerCSS = "",
  sticky = false,
  modifyPaginationCount = true,
}) => {
  const [pageCount, setPageCount] = useState(query?.Pagination?.Count ?? 25);
  const moduleName = module?.Name || "";

  useEffect(() => {
    setPageCount(query?.Pagination?.Count ?? 25);
  }, [query?.Pagination?.Count]);

  if (error) return null;

  const loadNextOrPreviousPage = (e, direction) => {
    e.preventDefault();

    if (typeof setSelectedRecords === "function") {
      setSelectedRecords({});
    }

    let newQuery = { ...query };

    newQuery.OrderBy = newQuery.OrderBy
      ? newQuery.OrderBy
      : {
          Field: "Created",
          Direction: "DESC",
        };

    newQuery.Pagination = {
      Count: pageCount,
      Page: pagination ? pagination[direction] : 1,
    };

    setQuery(newQuery);
  };

  const handlePageCountChange = (e) => {
    const { value } = e.target;

    if (typeof setSelectedRecords === "function") {
      setSelectedRecords({});
    }
    setPageCount(parseInt(value));

    let newQuery = { ...query };

    newQuery.OrderBy = newQuery.OrderBy
      ? newQuery.OrderBy
      : {
          Field: "Created",
          Direction: "DESC",
        };

    newQuery.Pagination = {
      Count: parseInt(value),
      Page: 1,
    };

    setQuery(newQuery);
  };

  const PaginationToolbar = (
    <div className={`px-3 py-2 py-sm-3 pr-4 ${containerCSS}`}>
      <Row className="align-items-center">
        <Col xs="12" sm="">
          <div className="d-inline-block mb-3 mb-sm-0">
            {loading ? (
              <small>Loading records...</small>
            ) : (
              <>
                {pagination && records?.length > 0 && (
                  <small>
                    Viewing &nbsp;
                    {StrUtils.numberFormat(pagination.ResultRecordsMin)} -{" "}
                    {StrUtils.numberFormat(pagination.ResultRecordsMax)} of{" "}
                    {StrUtils.numberFormat(pagination.TotalRecords)}{" "}
                    {moduleName ? (
                      <span className="text-capitalize">
                        {pluralize(moduleName?.toLowerCase(), 2)}
                      </span>
                    ) : (
                      " records"
                    )}
                  </small>
                )}
              </>
            )}
          </div>
        </Col>
        <Col xs="12" sm="auto">
          {modifyPaginationCount && (
            <div className="d-inline-block">
              <Input
                onChange={handlePageCountChange}
                value={pageCount}
                type="select"
                className="form-control"
                bsSize="sm"
                disabled={
                  loading ||
                  (typeof pagination?.TotalRecords === "number" &&
                    pagination?.TotalRecords < 25)
                }
              >
                <option value={25}>25 Records Per Page</option>
                <option value={50}>50 Records Per Page</option>
                <option value={100}>100 Records Per Page</option>
                <option value={250}>250 Records Per Page</option>
                <option value={500}>500 Records Per Page</option>
              </Input>
            </div>
          )}

          <div className="d-inline-block ml-3">
            <nav>
              <Pagination
                className="pagination justify-content-end mb-0"
                listClassName="justify-content-end mb-0"
                size="sm"
              >
                <PaginationItem
                  className={`${pagination?.PreviousPage ? "" : "disabled"}`}
                >
                  <PaginationLink
                    href="#"
                    onClick={(e) => loadNextOrPreviousPage(e, "PreviousPage")}
                    tabIndex="-1"
                  >
                    <i className="mdi mdi-chevron-left" />
                    <span className="sr-only">Previous</span>
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  className={`${pagination?.NextPage ? "" : "disabled"}`}
                >
                  <PaginationLink
                    href="#"
                    onClick={(e) => loadNextOrPreviousPage(e, "NextPage")}
                  >
                    <i className="mdi mdi-chevron-right" />
                    <span className="sr-only">Next</span>
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </nav>
          </div>
        </Col>
      </Row>
    </div>
  );

  if (sticky) {
    return (
      <div className="gc-table-pagination-sticky">{PaginationToolbar}</div>
    );
  }

  return PaginationToolbar;
};

export default AppTablePagination;
